<template>
  <div class="nav">
    <div class="inner">
      <a class="btn" @click.prevent="btnDept('婦產科')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="account"
              src="@/assets/images/nav_icon/nav_icon_account.svg"
            />
          </div>
          <p>婦產科</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('小兒科')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="pediatrics"
              src="@/assets/images/nav_icon/nav_icon_pediatrics.svg"
            />
          </div>
          <p>小兒科</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('皮膚科')" v-if="member.info.beta"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="pediatrics"
              src="@/assets/images/nav_icon/nav_icon_pediatrics.svg"
            />
          </div>
          <p>皮膚科</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('營養科')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="nutrition"
              src="@/assets/images/nav_icon/nav_icon_nutrition.svg"
            />
          </div>
          <p>營養師諮詢門診</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('助產諮詢科')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="anesthesia"
              src="@/assets/images/nav_icon/nav_icon_midwife.svg"
            />
          </div>
          <p>助產師諮詢門診</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('超音波影像門診')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="fetal"
              src="@/assets/images/nav_icon/nav_icon_fetal.svg"
            />
          </div>
          <p>超音波影像門診</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('VIP 特約門診')"
        ><div class="inner">
          <div class="nav_img">
            <img class="vip" src="@/assets/images/nav_icon/nav_icon_vip.svg" />
          </div>
          <p>VIP 特約門診</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('泌乳師課程預約')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="course"
              src="@/assets/images/nav_icon/nav_icon_anesthesia.svg"
            />
          </div>
          <p>泌乳師課程預約</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('乳房醫學')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="vip"
              src="@/assets/images/nav_icon/nav_icon_breast.svg?v230818"
            />
          </div>
          <p>乳房醫學</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('醫美')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="vip"
              src="@/assets/images/nav_icon/nav_icon_facial.svg?v230818"
            />
          </div>
          <p>醫美</p>
        </div></a
      >
      <a class="btn" @click.prevent="btnDept('外科')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="vip"
              src="@/assets/images/nav_icon/nav_icon_pelvis.svg?v230818"
            />
          </div>
          <p>外科</p>
        </div></a
      >
      <a class="btn disabled" @click.prevent="btnDept('快速門診')"
        ><div class="inner">
          <div class="nav_img">
            <img
              class="fast"
              src="@/assets/images/nav_icon/nav_icon_fast_s.svg"
            />
          </div>
          <p>快速門診</p>
        </div></a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentDepts",
  emits: ["changeDept"],
  data() {
    return {
      member: this.$store.state.member
    };
  },
  methods: {
    btnDept(dept) {
      this.$emit("changeDept", dept);
    }
  }
};
</script>
